var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classNames } from '../../utils';
export var EmptyPage = function (_a) {
    var className = _a.className, image = _a.image, title = _a.title, subTitle = _a.subTitle, isSmallScreen = _a.isSmallScreen;
    return (_jsxs("div", __assign({ className: classNames(className, "flex flex-col items-center justify-center ".concat(isSmallScreen ? 'pt-2' : 'pt-16', " text-center")) }, { children: [_jsx("img", { src: image, alt: "alien" }), _jsx("p", __assign({ className: "text-textDark text-18 mt-4 mb-2 font-semibold" }, { children: title })), _jsx("p", __assign({ className: "text-textMid" }, { children: subTitle }))] })));
};
//# sourceMappingURL=index.js.map